<template>
  <v-card class="elevation-7">
    <v-layout>
      <v-flex md6>
        <v-card flat outlined>
          <v-card-title
            class="caption grey--text text--darken-1 font-weight-medium padding vline"
            >Transaction Type</v-card-title
          >
          <v-divider class="border"></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Reload</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Sold</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Sold Credit</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Credit Redeem Count</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Balance</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Credit</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Transfer Count</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Transfer Fee Card</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Transfer Fee Cash</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text class="caption font-weight-regular padding vline"
            >Transfer Fee Gross</v-card-text
          >
          <v-divider class="border"></v-divider>
          <v-card-title class="caption font-weight-medium padding vline"
            >Total</v-card-title
          >
        </v-card>
      </v-flex>
      <v-flex md4>
        <v-card flat outlined>
          <v-card-title
            class="caption grey--text text--darken-1 font-weight-medium padding vline"
          >
            <v-spacer></v-spacer>Count
          </v-card-title>
          <v-divider class="border"></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ reloadCount }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ soldCount }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ soldCreditCount }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ creditRedeemCount }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ balanceCount }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ creditCount }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ transferCount }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ "--" }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ "--" }}</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            class="caption font-weight-regular textRight padding vline"
            >{{ "--" }}</v-card-text
          >
          <v-divider class="border"></v-divider>
          <v-card-text
            class="caption font-weight-medium textRight padding vline"
            >{{
              reloadCount +
                soldCount +
                balanceCount +
                creditCount +
                soldCreditCount +
                creditRedeemCount +
                transferCount
            }}</v-card-text
          >
        </v-card>
      </v-flex>
      <v-flex md4>
        <v-card flat outlined>
          <v-card-title
            class="caption grey--text text--darken-1 font-weight-medium padding"
          >
            <v-spacer></v-spacer>Gross
          </v-card-title>
          <v-divider class="border"></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(reloadGross) }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(soldGross) }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(soldCreditGross) }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ "--" }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ "--" }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(creditGross) }}
          </v-card-title>
                    <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ "--" }}
          </v-card-title>
                    <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(transferFeeCard) }}
          </v-card-title>
                    <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(transferFeeCash) }}
          </v-card-title>
                    <v-divider></v-divider>
          <v-card-title class="caption font-weight-regular padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(transferFeeGross) }}
          </v-card-title>          
          <v-divider class="border"></v-divider>
          <v-card-title class="caption font-weight-medium padding">
            <v-spacer></v-spacer>
            {{ $amountInPeso(grossRevenue) }}
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    reloadCount: {
      type: Number,
      default: 0,
    },
    soldCount: {
      type: Number,
      default: 0,
    },
    soldCreditCount: {
      type: Number,
      default: 0,
    },
    balanceCount: {
      type: Number,
      default: 0,
    },
    creditCount: {
      type: Number,
      default: 0,
    },
    creditRedeemCount: {
      type: Number,
      default: 0,
    },
    soldGross: {
      type: Number,
      default: 0,
    },
    soldCreditGross: {
      type: Number,
      default: 0,
    },
    reloadGross: {
      type: Number,
      default: 0,
    },
    creditGross: {
      type: Number,
      default: 0,
    },
    transferCount: {
      type: Number,
      default: 0,
    },
    transferFeeCard: {
      type: Number,
      default: 0,
    },
    transferFeeCash: {
      type: Number,
      default: 0,
    },
    transferFeeGross: {
      type: Number,
      default: 0,
    },
    grossRevenue: {
      type: Number,
      default: 0,
    },
    computedCreditgross: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style scoped>
.tableTotal {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  height: 95%;
  /* border: 3px solid #000000; */
}

.tableTotalTH {
  border: 1px solid #000000;
  text-align: center;
  padding: 8px;
  font-size: 20px;
  background-color: #757575;
  color: #fafafa;
}

.tableTotalTH2 {
  border: 1px solid #000000;
  text-align: left;
  padding: 8px;
  font-size: 18px;
}

.tableTotalTD {
  border: 1px solid #000000;
  text-align: left;
  padding: 8px;
  font-size: 16px;
  font-weight: bold;
}

.tableTotalTDRight {
  border: 1px solid #000000;
  text-align: right;
  padding: 8px;
  font-size: 16px;
  font-weight: bold;
}

.tableTotalTDRightSpecial {
  border: 1px solid #000000;
  text-align: right;
  padding: 8px;
  font-size: 16px;
  font-weight: bold;
  border-top: 3px solid #000000;
  border-bottom: 3px solid #000000;
}

.tableTotalTRSpecial {
  background-color: #f2f2f2;
  border-top: 3px solid #000000;
  border-bottom: 3px solid #000000;
}

.tableTotalTR:nth-child(even) {
  background-color: #f2f2f2;
}

.tableTotalTR:hover {
  background-color: #ddd;
}

.tableTotalTRSpecial:nth-child(even) {
  background-color: #f2f2f2;
}

.tableTotalTRSpecial:hover {
  background-color: #ddd;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.textRight {
  text-align: right;
}
.padding {
  padding: 7px;
}
.vline {
  border-right: 1px solid #eeeeee;
}
.border {
  border: 1px solid #e0e0e0;
}
</style>
